import type { ParsedQuery } from './types.js';

// "Severance S02E05" → tv/2/5; "Better Call Saul s06e13" → tv/6/13.
// Anything that doesn't end in S\d{1,2}E\d{1,2} is a movie title. Bare
// "S01E01" with no title in front matches but is rejected as missing-title.
const TV_SUFFIX = /(?:^|\s+)s(\d{1,2})e(\d{1,2})\s*$/i;

export function parseQuery(input: string): ParsedQuery {
  const trimmed = input.trim();
  if (trimmed.length === 0) {
    return { ok: false, error: '请输入电影名或剧集 (例：Severance S02E05)' };
  }
  const m = trimmed.match(TV_SUFFIX);
  if (m) {
    const title = trimmed.slice(0, m.index).trim();
    if (title.length === 0) {
      return { ok: false, error: '剧名缺失' };
    }
    const season = Number(m[1]);
    const episode = Number(m[2]);
    if (season < 1 || episode < 1) {
      return { ok: false, error: 'season/episode 必须 ≥ 1' };
    }
    return { ok: true, type: 'tv', title, season, episode };
  }
  return { ok: true, type: 'movie', title: trimmed };
}
